import { useContext } from 'react';

import { TimeseriesYAxisContext } from '../context/TimeseriesYAxis.context.js';

export const useYAxisConfig = () => useContext(TimeseriesYAxisContext);
